import i18next from 'i18next';
import { getLogger } from '@cld/upload-widget-common';
import dicts from 'root/translations';

const UW_NS = 'translation';
const logger = getLogger();

let i18nInstance;

const init = () => {
  i18nInstance = i18next.createInstance();

  i18nInstance.init(
    {
      lng: 'en',
      fallbackLng: 'en',
      resources: dicts,
      defaultNS: UW_NS,
    },
    (err) => {
      if (err) {
        logger.error('[i18n]: encountered error while initializing languages! ', err);
      }
    }
  );
};

const changeLanguage = (lang, callback) =>
  i18nInstance.changeLanguage(lang, (err) => {
    if (err) {
      logger.error('[i18n]: encountered error changing language! ', err);
    } else {
      logger.log(`[i18n]: successfully change language to: ${lang}`);
    }

    callback?.(err);
  });

const setLanguage = (lang, callback) => {
  if (!~i18nInstance.languages[lang]) {
    i18nInstance.loadLanguages([lang], (err) => {
      if (err) {
        logger.error(`[i18n]: failed to load language: ${lang}`);
      } else {
        changeLanguage(lang, callback);
      }
    });
  } else {
    changeLanguage(lang, callback);
  }
};

/**
 * add resources in a nested structure starting from the language
 *
 * @param dicts should be object map of the following shape:
 *          {
 *              en: {...},
 *              de: {...},
 *              ...
 *          }
 *  should include at least one language as the first level name
 */
const addValues = (dicts) => {
  Object.keys(dicts).forEach((lang) => {
    logger.log(`[i18n]: adding resources for language: ${lang}`);
    //must remove immutability or i18next stores the immutable object, causing errors when trying to update again
    const values = dicts[lang].asMutable?.({ deep: true }) || dicts[lang];
    i18nInstance.addResourceBundle(lang, UW_NS, values, true, true);
  });
};

init(); // load the dictionary as soon as possible !

// self.__dicts =  dicts;

const getInstance = () => i18nInstance;

export default (key, options = {}) => i18nInstance.t(key, options);

export { addValues, setLanguage, getInstance };
